// src/styles/theme.js
export const theme = {
  colors: {
    lightBg: '#ffffff',
    lightBg2: '#f8fafc',
    lightBg3: '#e5edfa',
    blue: '#3b82f6',
    blueLight: '#60a5fa',
    text: '#222222',
    textLight: '#4b5563',
    gray: '#94a3b8',
    grayLight: '#cbd5e1',
    border: '#e5e7eb',
  },
  radius: {
    lg: '20px',
    md: '12px',
    sm: '6px',
  },
  shadow: {
    card: '0 8px 32px rgba(59, 130, 246, 0.08)',
  },
};
